/*
 * FRMWRK a11y helper — 09 Jul 2026
 * Some custom editorial sections ship <img> without an alt attribute, so screen
 * readers announce the raw file name. Give any alt-less image an empty (decorative)
 * alt so assistive tech skips it. Never overrides an existing alt. Also covers
 * images inserted later via AJAX (recommendations, filtered collections).
 */
(function () {
  function fix(root) {
    if (!root || !root.querySelectorAll) return;
    var imgs = root.querySelectorAll('img:not([alt])');
    for (var i = 0; i < imgs.length; i++) imgs[i].setAttribute('alt', '');
  }
  function start() {
    fix(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'IMG' && !n.hasAttribute('alt')) n.setAttribute('alt', '');
          fix(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
